import { api } from './client';

export interface TrustedRecipient { email: string; name: string }
export function searchRecipients(query: string) {
  return api.get<{ recipients: TrustedRecipient[] }>(`/recipients?q=${encodeURIComponent(query)}`);
}
